import { render, staticRenderFns } from "./searchtitle.vue?vue&type=template&id=ac906b74&"
import script from "./searchtitle.vue?vue&type=script&lang=js&"
export * from "./searchtitle.vue?vue&type=script&lang=js&"
import style0 from "./searchtitle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports